var _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 50,
    fill: "#333",
    r: 20
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "30;70;30",
    begin: "-0.5s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 50,
    fill: "#999",
    r: 20
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "30;70;30",
    begin: "0s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 50,
    fill: "#333",
    r: 20
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "30;70;30",
    begin: "-0.5s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0;0;1;1",
    calcMode: "discrete",
    keyTimes: "0;0.499;0.5;1",
    dur: "1s",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.512c6e7ee61ff52afe29f59b58e53bd0.svg";
export { ForwardRef as ReactComponent };